import React, { useEffect, useState, useCallback } from 'react'
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import { FaEdit, FaTrash } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import '../Customcss/table.css'
import Puff from 'react-loading-icons/dist/esm/components/puff';
import { useStateContext } from '../Context/ContextProvider';
import { toast } from 'react-toastify';
import UOMSelector from './UomSelector';
import TransTypeSearchDropdown from './TransTypeSearchDropdown';
import HsCodeSearchDropdown from './HsCodeSearchDropdown';
import SaleTypeRateDropdown from './SaleTypeRateDropdown';
import SroDropdown from './SroDropdown';
import SroItemDropdown from './SroItemDropdown';

function Product() {

  const { type, weburl } = useStateContext();
  const [isClick, setIsClick] = useState(false);
  
  const [isThisClick, setIsThisClick] = useState('');
  const [category, setCategory] = useState([]);
  const [distributer, setDistributer] = useState([]);
  const [defaultCategory, setDefaultCategory] = useState('');
  const [defaultStore, setDefaultStore] = useState('');
  const [defaultDistributer, setDefaultDistributer] = useState('');
  const [store, setStore] = useState([]);
  const [packsaleprice, setPackSalePrice] = useState('');
  const [packcostprice, setPackCostPrice] = useState('');
  const [unitsaleprice, setUnitSalePrice] = useState('');
  const [unitcostprice, setUnitCostPrice] = useState('');
  const [qty, setQty] = useState('1');
  const [pcs, setPcs] = useState('');
  const [packsize, setPackSize] = useState('1');
  const [packqty, setPackQty] = useState('1');
  const [unitretailprice, setUnitRetailPrice] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [productid, setProductId] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviewEdit, setImagePreviewEdit] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState('');
  const [serialStart, setSerialStart] = useState('');
  const [file, setFile] = useState(null);
  const [batchId, setBatchId] = useState('');
  const [progress, setProgess] = useState(1);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // State for HSCode
  const [defaultHsCode, setDefaultHsCode] = useState('');
  
  // State for Transaction Type - Store as string
  const [defaultTransType, setDefaultTransType] = useState('');
  const [defaultTransTypeDesc, setDefaultTransTypeDesc] = useState('');
  const [defaultTransTypeId, setDefaultTransTypeId] = useState('');

  // ============================================
  // DEFAULT PRODUCT STATE
  // ============================================
  const defaultProductState = {
    name: '',
    alias: '',
    weight: '0',
    color: '',
    unit: 'Pcs',
    hold: '1',
    alert: '',
    aisle: '',
    bin: '',
    uom_id: '',
    uom_des: '',
    rate_id: '',
    rate_value: '',
    rate_description: '',
    extraDiscount: '0',
    unitwholesaleprice: '',
    hscode: '',
    trans_type_id: '',
    trans_type_des: '',
    sro_id: '',
    sro_desc: '',
    sro_item_id: '',
    sro_item_desc: '',
    errorlist: [],
  };

  const [inputProduct, setInputProduct] = useState(defaultProductState);

  // ============================================
  // UOM SELECTION HANDLER
  // ============================================
  const handleUOMSelection = (uomData) => {
    console.log(uomData);
    if (uomData) {
      setInputProduct(prev => ({
        ...prev,
        uom_id: uomData.id,
        uom_des: uomData.description
      }));
    } else {
      setInputProduct(prev => ({
        ...prev,
        uom_id: '',
        uom_des: ''
      }));
    }
  };

  // ============================================
  // DATE FORMAT FUNCTIONS
  // ============================================
  const getFormattedDateForSroItem = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getFormattedDateForSro = () => {
    return new Date().toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    }).replace(/ /g, '-');
  };

  // ============================================
  // SRO SELECTION HANDLER
  // ============================================
  const handleSroSelect = (sroData) => {
    if (sroData) {
      setInputProduct(prev => ({
        ...prev,
        sro_id: sroData.id,
        sro_desc: sroData.description
      }));
    } else {
      setInputProduct(prev => ({
        ...prev,
        sro_id: '',
        sro_desc: ''
      }));
    }
  };

  // ============================================
  // SRO ITEM SELECTION HANDLER
  // ============================================
  const handleSroItemSelect = (sroItemData) => {
    if (sroItemData) {
      setInputProduct(prev => ({
        ...prev,
        sro_item_id: sroItemData.id,
        sro_item_desc: sroItemData.description
      }));
    } else {
      setInputProduct(prev => ({
        ...prev,
        sro_item_id: '',
        sro_item_desc: ''
      }));
    }
  };

  // ============================================
  // EXISTING FUNCTIONS
  // ============================================
  
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmitImport = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await axios.post('api/import/products', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('Response:', response.data);
      setBatchId(response.data.batchId);
      setIsLoading(false);
      setError(response.data.message);
    } catch (error) {
      console.error('Error uploading file:', error);
      setError(error.message);
      setIsLoading(false);
    }
  };

  const updateProgress = useCallback(() => {
    axios.get(`api/batch/${batchId}`).then(response => {
      setProgess(response.data.progress);
      console.log(response.data);
    });
  }, [batchId]);

  useEffect(() => {
    const fetchData = async () => {
      if (batchId || progress > 1) {
        updateProgress();
      }
    };
    fetchData();
  }, [batchId, progress, updateProgress]);

  const HandleSetProductId = (e) => {
    e.preventDefault();
    setInputProduct(defaultProductState);
    setPackSalePrice('');
    setPackQty('1');
    setPackCostPrice('');
    setProductId('');
    setUnitRetailPrice('');
    setPackSize('1');
    setPcs('');
    setQty('1');
    setDefaultHsCode('');
    setDefaultTransType('');
    setDefaultTransTypeDesc('');
    setDefaultTransTypeId('');
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 20480) {
      setImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      toast.error('Image Size Should Be Less Than 20kb', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    axios.get(`/api/view/products?page=${currentPage}&search=${searchQuery}`).then(response => {
      setItemsPerPage(response.data.products.per_page);
      setProducts(response.data.products.data);
      setTotalPages(response.data.products.last_page);
    })
  }, [currentPage, searchQuery, isThisClick, isClick]);

  useEffect(() => {
    setSerialStart((currentPage - 1) * itemsPerPage + 1);
  }, [currentPage, itemsPerPage]);

  const handlePackSalePrice = (e) => {
    setPackSalePrice(e.target.value);
    setUnitSalePrice(parseFloat(e.target.value / packsize).toFixed(2));
  };

  const handlePackCostPrice = (e) => {
    setPackCostPrice(e.target.value);
    setUnitCostPrice(parseFloat(e.target.value / packsize).toFixed(2))
  };

  const handlePackSize = (e) => {
    setPackSize(e.target.value);
    setQty(parseFloat(e.target.value === '' ? 1 : e.target.value) * parseFloat(packqty === '' ? 0 : packqty) + parseFloat(pcs === '' ? 0 : pcs === '' ? 0 : pcs))
    setUnitCostPrice(parseFloat(packcostprice / parseFloat(e.target.value === '' ? 1 : e.target.value)).toFixed(2));
    setUnitSalePrice(parseFloat(packsaleprice / parseFloat(e.target.value === '' ? 1 : e.target.value)).toFixed(2));
  };

  const handlePackQty = (e) => {
    setPackQty(e.target.value);
    setQty(parseInt(e.target.value === '' ? 0 : e.target.value * packsize) + parseInt(pcs === '' ? 0 : pcs))
  };

  const handleChangeUnitCostPrice = (e) => {
    setUnitCostPrice(e.target.value);
    setPackCostPrice(parseFloat(e.target.value * packsize).toFixed(2));
  };

  const handleChangeUnitSalePrice = (e) => {
    setUnitSalePrice(e.target.value);
    setPackSalePrice(parseFloat(e.target.value * packsize).toFixed(2));
  };

  const handlePcsChange = (e) => {
    const newqty = parseInt(e.target.value === '' ? 0 : e.target.value) + (parseInt(packqty === '' ? 0 : packqty) * parseInt(packsize === '' ? 1 : packsize));
    setQty(newqty);
    setPackQty(Math.floor(parseInt(newqty) / parseInt(packsize === '' ? 1 : packsize)));
    setPcs(parseInt(newqty) % parseInt(packsize === '' ? 1 : packsize));
  };

  const handleQtyChange = (e) => {
    setQty(e.target.value);
    setPackQty(Math.floor(parseInt(e.target.value === '' ? 0 : e.target.value) / parseInt(packsize === '' ? 1 : packsize)))
    setPcs((parseInt(e.target.value === '' ? 0 : e.target.value) % parseInt(packsize === '' ? 1 : packsize)))
  };

  const handleInput = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setInputProduct({ ...inputProduct, [name]: value });
  }

  useEffect(() => {
    axios.get(`/api/fetch/distributer`).then(response => {
      setDistributer(response.data.user);
      setDefaultDistributer(response.data.user[0]?.id || '');
    })
  }, []);

  useEffect(() => {
    axios.get(`/api/fetch/category`).then(response => {
      setCategory(response.data.category);
      setDefaultCategory(response.data.category[0]?.id || '');
    })
  }, []);

  useEffect(() => {
    axios.get(`/api/fetch/store`).then(response => {
      setStore(response.data.store);
      setDefaultStore(response.data.store[0]?.id || '');
    })
  }, []);

  // ============================================
  // HANDLE TRANSACTION TYPE CHANGE
  // ============================================
  const handleTransactionChange = (data) => {
    if (data && data.transactioN_TYPE_ID) {
      const idAsString = String(data.transactioN_TYPE_ID);
      setDefaultTransType(idAsString);
      setDefaultTransTypeId(idAsString);
      setDefaultTransTypeDesc(data.transactioN_DESC || '');
      
      setInputProduct(prev => ({
        ...prev,
        trans_type_id: idAsString,
        trans_type_des: data.transactioN_DESC || ''
      }));
    } else {
      setDefaultTransType('');
      setDefaultTransTypeId('');
      setDefaultTransTypeDesc('');
      setInputProduct(prev => ({
        ...prev,
        trans_type_id: '',
        trans_type_des: ''
      }));
    }
  };

  // ============================================
  // HANDLE RATE SELECTION
  // ============================================
  const handleRateSelect = (rateData) => {
    if (rateData && rateData.id) {
      setInputProduct(prev => ({
        ...prev,
        rate_id: rateData.id,
        rate_value: rateData.value || '',
        rate_description: rateData.description || ''
      }));
    } else {
      setInputProduct(prev => ({
        ...prev,
        rate_id: '',
        rate_value: '',
        rate_description: ''
      }));
    }
  };

  // ============================================
  // HANDLE SUBMIT
  // ============================================
  const handleSubmit = (e) => {
    setIsClick(true);
    e.preventDefault();
    const defaultData = {
      category_id: defaultCategory,
      distributer_id: defaultDistributer,
      store_id: defaultStore,
      pack_sale_price: packsaleprice,
      pack_cost_price: packcostprice,
      unitsaleprice: unitsaleprice,
      unitcostprice: unitcostprice,
      pack_size: packsize,
      pack_qty: packqty,
      qty: qty,
      unitretailprice: unitretailprice,
      hscode: defaultHsCode,
      trans_type_id: defaultTransTypeId || defaultTransType,
      trans_type_des: defaultTransTypeDesc,
      uom_id: inputProduct.uom_id || '',
      uom_des: inputProduct.uom_des || '',
      rate_id: inputProduct.rate_id || '',
      rate_value: inputProduct.rate_value || '',
      rate_description: inputProduct.rate_description || '',
      sro_id: inputProduct.sro_id || '',
      sro_desc: inputProduct.sro_desc || '',
      sro_item_id: inputProduct.sro_item_id || '',
      sro_item_desc: inputProduct.sro_item_desc || '',
    };
   
    const formData = new FormData();
    formData.append('image', image);
    for (const key in defaultData) {
      formData.append(key, defaultData[key]);
    }
    for (const key in inputProduct) {
      formData.append(key, inputProduct[key]);
    }
    axios
      .post('api/add/product', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.data.status === 200) {
          toast.success('Item Successfully Added!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setInputProduct(defaultProductState);
          setPackSalePrice('');
          setPackQty('1');
          setPackCostPrice('');
          setProductId('');
          setUnitRetailPrice('');
          setDefaultHsCode('');
          setIsClick(false);
          setDefaultTransType('');
          setDefaultTransTypeId('');
          setDefaultTransTypeDesc('');
        } else if (res.data.status === 400) {
          toast.error(res.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsClick(false);
        } else {
          setInputProduct({ ...inputProduct, errorlist: res.data.validation_errors });
          setIsClick(false);
        }
        setIsClick(false);
      });
  };

  // ============================================
  // HANDLE DELETE
  // ============================================
  const handleDelete = (e, id, index) => {
    setIsThisClick(index);
    axios.delete(`api/delete/product/${id}`).then(res => {
      if (res.data.status === 200) {
        toast.success('Item Deleted Successfully!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setIsThisClick('');
      } else {
      }
    })
  };

  // ============================================
  // HANDLE EDIT
  // ============================================
  const handleEdit = (e, id, index) => {
    e.preventDefault();
    setIsThisClick(index);
    setProductId(id);
    axios.get(`api/edit/product/${id}`).then(res => {
      setDefaultCategory(res.data.product.category_id);
      setDefaultStore(res.data.product.store_id);
      setDefaultDistributer(res.data.product.distributer_id);
      setPackQty(Math.floor(res.data.product.qty / res.data.product.pack_size));
      setPackSize(res.data.product.pack_size);
      setQty(res.data.product.qty);
      setPcs(res.data.product.qty % res.data.product.pack_size);
      setPackSalePrice(res.data.product.pack_sale_price);
      setPackCostPrice(res.data.product.pack_cost_price);
      setUnitCostPrice(res.data.product.unitcostprice);
      setUnitSalePrice(res.data.product.unitsaleprice);
      setUnitRetailPrice(res.data.product.unitretailprice === null ? '0' : res.data.product.unitretailprice);
      
      const hsCodeValue = res.data.product.hscode || '';
      setDefaultHsCode(hsCodeValue);
      
      const transTypeValue = res.data.product.trans_type_id ? String(res.data.product.trans_type_id) : '';
      setDefaultTransType(transTypeValue);
      setDefaultTransTypeId(transTypeValue);
      setDefaultTransTypeDesc(res.data.product.trans_type_des || '');

      setImagePreview(null);
      setImagePreviewEdit(res.data.product.image);
      const updateitems = {
        ...inputProduct,
        'name': res.data.product.name === null ? '' : res.data.product.name,
        'color': res.data.product.color === null ? '' : res.data.product.color,
        'weight': res.data.product.weight === null ? '' : res.data.product.weight,
        'unit': res.data.product.unit === null ? '' : res.data.product.unit,
        'alert': res.data.product.productalert === null ? '' : res.data.product.productalert,
        'hold': res.data.product.hold === null ? '' : res.data.product.hold,
        'alias': res.data.product.alias === null ? '' : res.data.product.alias,
        'aisle': res.data.product.class === null ? '' : res.data.product.class,
        'bin': res.data.product.box === null ? '' : res.data.product.box,
        'unitwholesaleprice': res.data.product.unitwholesaleprice === null ? '0' : res.data.product.unitwholesaleprice,
        'extraDiscount': res.data.product.extra_discount === null ? '0' : res.data.product.extra_discount,
        'hscode': res.data.product.hscode || '',
        'trans_type_id': transTypeValue,
        'trans_type_des': res.data.product.trans_type_des || '',
        'uom_id': res.data.product.uom_id || '',
        'uom_des': res.data.product.uom_des || '',
        'sro_id': res.data.product.sro_id || '',
        'sro_desc': res.data.product.sro_desc || '',
        'sro_item_id': res.data.product.sro_item_id || '',
        'sro_item_desc': res.data.product.sro_item_desc || '',
      }
    
      setInputProduct(updateitems);
      setIsThisClick('');
    });
  };

  // ============================================
  // HANDLE UPDATE
  // ============================================
  const handleUpdate = (e) => {
    setIsClick(true);
    e.preventDefault();
    const defaultData = {
      'category_id': defaultCategory,
      'distributer_id': defaultDistributer,
      'store_id': defaultStore,
      'pack_sale_price': packsaleprice,
      'pack_cost_price': packcostprice,
      'unitsaleprice': unitsaleprice,
      'unitcostprice': unitcostprice,
      'pack_size': packsize,
      'pack_qty': packqty,
      'qty': qty,
      'unitretailprice': unitretailprice,
      'productid': productid,
      'hscode': defaultHsCode,
      'trans_type_id': defaultTransTypeId || defaultTransType,
      'trans_type_des': defaultTransTypeDesc,
      'uom_id': inputProduct.uom_id || '',
      'uom_des': inputProduct.uom_des || '',
      'rate_id': inputProduct.rate_id || '',
      'rate_value': inputProduct.rate_value || '',
      'rate_description': inputProduct.rate_description || '',
      'sro_id': inputProduct.sro_id || '',
      'sro_desc': inputProduct.sro_desc || '',
      'sro_item_id': inputProduct.sro_item_id || '',
      'sro_item_desc': inputProduct.sro_item_desc || '',
    }
    
    const formData = new FormData();
    formData.append('image', image);
    for (const key in defaultData) {
      formData.append(key, defaultData[key]);
    }
    for (const key in inputProduct) {
      formData.append(key, inputProduct[key]);
    }
    axios.post('api/update/product', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(res => {
      if (res.data.status === 401) {
        setInputProduct({ ...inputProduct, errorlist: res.data.validation_errors });
      } else if (res.data.status === 400) {
        toast.error(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setImagePreviewEdit(null);
      } else {
        toast.success('Item Updated Successfully!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setImagePreviewEdit(null);
      }
      setIsClick(false);
    })
  };

  // ============================================
  // HANDLE EXPORT
  // ============================================
  const handleExport = () => {
    setIsClick(true);
    axios({
      url: 'api/products/export',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'products.xlsx');
      document.body.appendChild(link);
      link.click();
      setIsClick(false);
    });
  };

  const handleExportPdf = () => {
    setIsClick(true);
    axios({
      url: 'api/products/export/pdf',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      setIsClick(false);
    });
  };

  // ============================================
  // STYLES
  // ============================================
  const styles = {
    container: {
      padding: '20px',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
    },
    formContainer: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      padding: '30px',
      marginBottom: '30px',
      border: '1px solid #e9ecef',
    },
    formTitle: {
      color: '#2c3e50',
      fontWeight: '600',
      fontSize: '24px',
      marginBottom: '20px',
      paddingBottom: '15px',
      borderBottom: '3px solid #3498db',
      display: 'inline-block',
    },
    input: {
      borderRadius: '8px',
      border: '1px solid #ced4da',
      padding: '10px 12px',
      transition: 'border-color 0.3s, box-shadow 0.3s',
    },
    button: {
      borderRadius: '8px',
      padding: '10px 25px',
      fontWeight: '500',
      transition: 'all 0.3s ease',
      marginRight: '10px',
    },
    buttonPrimary: {
      backgroundColor: '#3498db',
      border: 'none',
      color: '#fff',
    },
    buttonSuccess: {
      backgroundColor: '#2ecc71',
      border: 'none',
      color: '#fff',
    },
    buttonDanger: {
      backgroundColor: '#e74c3c',
      border: 'none',
      color: '#fff',
    },
    buttonWarning: {
      backgroundColor: '#f39c12',
      border: 'none',
      color: '#fff',
    },
    tableContainer: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      padding: '20px',
      border: '1px solid #e9ecef',
      marginTop: '30px',
    },
    tableHeader: {
      backgroundColor: '#f8f9fa',
      fontWeight: '600',
      color: '#2c3e50',
    },
    searchBar: {
      borderRadius: '8px',
      border: '1px solid #ced4da',
      padding: '10px 15px',
      width: '100%',
      transition: 'border-color 0.3s, box-shadow 0.3s',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '15px',
      marginTop: '20px',
    },
    imagePreview: {
      width: '50px',
      height: '50px',
      borderRadius: '8px',
      objectFit: 'cover',
      border: '2px solid #e9ecef',
    },
    errorText: {
      color: '#e74c3c',
      fontSize: '12px',
      marginTop: '5px',
    },
  };

  // ============================================
  // RENDER COMPONENT
  // ============================================
  return (
    <div style={styles.container}>
      {/* Form Section */}
      <div style={styles.formContainer}>
        {productid ? (
          <center>
            <form encType="multipart/form-data" onSubmit={handleUpdate} method='post'>
              <div style={{ maxWidth: '900px', width: '100%' }}>
                <h2 style={styles.formTitle}>Edit Product</h2>
                <hr style={{ marginBottom: '25px' }} />
                <Row className="g-3">
                  <div className='col-md-6'>
                    <FloatingLabel label="Product Name">
                      <Form.Control 
                        type="text" 
                        name="name" 
                        placeholder="Product Name" 
                        value={inputProduct.name} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.name}</span>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-6'>
                    <FloatingLabel label="Product Weight">
                      <Form.Control 
                        type="number" 
                        name="weight" 
                        placeholder="Product weight" 
                        value={inputProduct.weight} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-3'>
                    <FloatingLabel label="Cotton">
                      <Form.Control 
                        type="number" 
                        name="pack_qty" 
                        placeholder='pack qty' 
                        value={packqty} 
                        onChange={(e) => handlePackQty(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Size">
                      <Form.Control 
                        type="number" 
                        name="pack_size" 
                        placeholder='pack size' 
                        value={packsize} 
                        onChange={(e) => handlePackSize(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Pcs">
                      <Form.Control 
                        type="number" 
                        name="pcs" 
                        placeholder='pcs' 
                        value={pcs} 
                        onChange={(e) => handlePcsChange(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Total Qty">
                      <Form.Control 
                        type="number" 
                        name="qty" 
                        placeholder='qty' 
                        value={qty} 
                        onChange={(e) => handleQtyChange(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Qty Alert">
                      <Form.Control 
                        type="number" 
                        name="alert" 
                        placeholder='alert' 
                        value={inputProduct.alert} 
                        onChange={handleInput} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Pack Retail Price">
                      <Form.Control 
                        type="number" 
                        name="pack_sale_price" 
                        placeholder='pack sale price' 
                        value={packsaleprice} 
                        onChange={(e) => handlePackSalePrice(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.pack_sale_price}</span>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Pack Cost Price">
                      <Form.Control 
                        type="number" 
                        name="pack_cost_price" 
                        placeholder='pack cost price' 
                        value={packcostprice} 
                        onChange={(e) => handlePackCostPrice(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.pack_cost_price}</span>
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Unit Retail Price">
                      <Form.Control 
                        type="number" 
                        name="unitsaleprice" 
                        placeholder='unitsaleprice' 
                        value={unitsaleprice} 
                        onChange={(e) => handleChangeUnitSalePrice(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Unit Cost Price">
                      <Form.Control 
                        type="number" 
                        name="unitcostprice" 
                        placeholder='unitcostprice' 
                        value={unitcostprice} 
                        onChange={(e) => handleChangeUnitCostPrice(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Unit Wholesale Price">
                      <Form.Control 
                        type="number" 
                        value={inputProduct.unitwholesaleprice} 
                        name="unitwholesaleprice" 
                        placeholder='unitwholesaleprice' 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Unit">
                      <Form.Select 
                        aria-label="Product Unit" 
                        value={inputProduct.unit} 
                        name='unit' 
                        onChange={(e) => handleInput(e)}
                        style={styles.input}
                      >
                        <option value="Pcs">Pcs</option>
                        <option value="Box">Box</option>
                        <option value="Dzn">Dzn</option>
                        <option value="Grm">Grm</option>
                        <option value="Kg">Kg</option>
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Category">
                      <Form.Select 
                        aria-label="Product Category" 
                        value={defaultCategory} 
                        name='category_id' 
                        onChange={(e) => setDefaultCategory(e.target.value)}
                        style={styles.input}
                      >
                        {category && category.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Distributer Name">
                      <Form.Select 
                        aria-label="Distributer Name" 
                        value={defaultDistributer} 
                        name='distributer_id' 
                        onChange={(e) => setDefaultDistributer(e.target.value)}
                        style={styles.input}
                      >
                        {distributer && distributer.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Store Name">
                      <Form.Select 
                        aria-label="Store Name" 
                        value={defaultStore} 
                        name='store_id' 
                        onChange={(e) => setDefaultStore(e.target.value)}
                        style={styles.input}
                      >
                        {store && store.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Extra Discount">
                      <Form.Control 
                        type="text" 
                        name="extraDiscount" 
                        placeholder="Extra Discount" 
                        value={inputProduct.extraDiscount} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.extraDiscount}</span>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <input 
                      className='form-control' 
                      name='image' 
                      type="file" 
                      accept="image/*" 
                      onChange={handleImageChange} 
                      style={styles.input}
                    />
                  </div>
                  <div className='col-md-4'>
                    {imagePreviewEdit && <img src={`${weburl}${imagePreviewEdit}`} alt="Preview" style={styles.imagePreview} />}
                    {imagePreview && <img alt='uploaded' src={imagePreview} style={styles.imagePreview} />}
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Aisle">
                      <Form.Control 
                        type="text" 
                        name="aisle" 
                        placeholder="Product Aisle" 
                        value={inputProduct.aisle} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Bin">
                      <Form.Control 
                        type="text" 
                        name="bin" 
                        placeholder="Product Bin" 
                        value={inputProduct.bin} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Visibility">
                      <Form.Select 
                        aria-label="Product Visibility" 
                        value={inputProduct.hold} 
                        name='hold' 
                        onChange={(e) => handleInput(e)}
                        style={styles.input}
                      >
                        <option value="1">Yes</option>
                        <option value="2">No</option>
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Barcode">
                      <Form.Control 
                        type="text" 
                        name="alias" 
                        placeholder="Product Alias" 
                        value={inputProduct.alias} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                </Row>
                
                <Row className="g-3 mt-2">
                  <div className='col-md-6'>
                    <HsCodeSearchDropdown
                      value={defaultHsCode}
                      onChange={(code) => {
                        setDefaultHsCode(code);
                        setInputProduct(prev => ({ ...prev, hscode: code }));
                      }}
                      placeholder="Search HS Code..."
                      className="mb-2"
                    />
                  </div>
                  <div className="col-md-6">
                   <UOMSelector 
                    hsCode={defaultHsCode}
                    value={inputProduct.uom_id}
                    onUOMSelect={handleUOMSelection}
                    autoSelect={true}
                  />
                  </div>
                </Row>

                <Row className="g-3 mt-2">
                  <div className='col-md-6'>
                    <TransTypeSearchDropdown
                      value={defaultTransType}
                      onChange={handleTransactionChange}
                      placeholder="Search Transaction Type..."
                    />
                  </div>
                  <div className='col-md-6'>
                    <SaleTypeRateDropdown
                      transTypeId={defaultTransTypeId || defaultTransType}
                      originationSupplier="7"
                      onSelect={handleRateSelect}
                      placeholder="Search Sale Type Rate..."
                      className="mb-2"
                      required={false}
                    />
                  </div>
                </Row>
                <Row className='g-3 mt-2'>
                  <div className='col-md-6'>
                    <SroDropdown
                      rateId={inputProduct.rate_id || ''}
                      date={getFormattedDateForSro()}
                      originationSupplier="7"
                      value={inputProduct.sro_id || ''}
                      onSelect={handleSroSelect}
                      placeholder="Search SRO Schedule..."
                      className="mb-2"
                      required={false}
                    />
                  </div>
                  <div className='col-md-6'>
                    <SroItemDropdown
                      sroId={inputProduct.sro_id || ''}
                      date={getFormattedDateForSroItem()}
                      value={inputProduct.sro_item_id || ''}
                      onSelect={handleSroItemSelect}
                      placeholder="Search SRO Item..."
                      className="mb-2"
                      required={false}
                    />
                  </div>
                </Row>

                <Row className="g-3 mt-3">
                  <div className='col-md-6'>
                    <button 
                      className='btn btn-success btn-lg' 
                      style={{...styles.button, ...styles.buttonSuccess, width: '100%'}}
                    >
                      {isClick ? <Puff height={23} stroke='yellow' strokeOpacity={1.2} /> : 'Update'}
                    </button>
                  </div>
                  <div className='col-md-6'>
                    <button 
                      className='btn btn-danger btn-lg' 
                      onClick={(e) => HandleSetProductId(e)}
                      style={{...styles.button, ...styles.buttonDanger, width: '100%'}}
                    >
                      Add New
                    </button>
                  </div>
                </Row>
              </div>
            </form>
          </center>
        ) : (
          <center>
            <form encType="multipart/form-data" onSubmit={handleSubmit} method='post'>
              <div style={{ maxWidth: '900px', width: '100%' }}>
                <h2 style={styles.formTitle}>Add Product</h2>
                <hr style={{ marginBottom: '25px' }} />
                <Row className="g-3">
                  <div className='col-md-6'>
                    <FloatingLabel label="Product Name">
                      <Form.Control 
                        type="text" 
                        name="name" 
                        placeholder="Product Name" 
                        value={inputProduct.name} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.name}</span>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-6'>
                    <FloatingLabel label="Product Weight">
                      <Form.Control 
                        type="number" 
                        name="weight" 
                        placeholder="Product weight" 
                        value={inputProduct.weight} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-3'>
                    <FloatingLabel label="Cotton">
                      <Form.Control 
                        type="number" 
                        name="pack_qty" 
                        placeholder='pack qty' 
                        value={packqty} 
                        onChange={(e) => handlePackQty(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Size">
                      <Form.Control 
                        type="number" 
                        name="pack_size" 
                        placeholder='pack size' 
                        value={packsize} 
                        onChange={(e) => handlePackSize(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Pcs">
                      <Form.Control 
                        type="number" 
                        name="pcs" 
                        placeholder='pcs' 
                        value={pcs} 
                        onChange={(e) => handlePcsChange(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Total Qty">
                      <Form.Control 
                        type="number" 
                        name="qty" 
                        placeholder='qty' 
                        value={qty} 
                        onChange={(e) => handleQtyChange(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Qty Alert">
                      <Form.Control 
                        type="number" 
                        name="alert" 
                        placeholder='alert' 
                        value={inputProduct.alert} 
                        onChange={handleInput} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Cotton Retail Price">
                      <Form.Control 
                        type="number" 
                        name="pack_sale_price" 
                        placeholder='pack sale price' 
                        value={packsaleprice} 
                        onChange={(e) => handlePackSalePrice(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.pack_sale_price}</span>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Cotton Cost Price">
                      <Form.Control 
                        type="number" 
                        name="pack_cost_price" 
                        placeholder='pack cost price' 
                        value={packcostprice} 
                        onChange={(e) => handlePackCostPrice(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.pack_cost_price}</span>
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Unit Retail Price">
                      <Form.Control 
                        type="number" 
                        name="unitsaleprice" 
                        placeholder='unitsaleprice' 
                        value={unitsaleprice} 
                        onChange={(e) => handleChangeUnitSalePrice(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Unit Cost Price">
                      <Form.Control 
                        type="number" 
                        name="unitcostprice" 
                        placeholder='unitcostprice' 
                        value={unitcostprice} 
                        onChange={(e) => handleChangeUnitCostPrice(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Unit Wholesale Price">
                      <Form.Control 
                        type="text" 
                        name="unitwholesaleprice" 
                        placeholder="Product WholeSalePrice" 
                        value={inputProduct.unitwholesaleprice} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.unitwholesaleprice}</span>
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Unit">
                      <Form.Select 
                        aria-label="Product Unit" 
                        name='unit' 
                        value={inputProduct.unit} 
                        onChange={(e) => handleInput(e)}
                        style={styles.input}
                      >
                        <option value="Box">Box</option>
                        <option value="Dzn">Dzn</option>
                        <option value="Pcs">Pcs</option>
                        <option value="Grm">Grm</option>
                        <option value="Kg">Kg</option>
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Product Category">
                      <Form.Select 
                        aria-label="Product Category" 
                        name='category_id' 
                        onChange={(e) => setDefaultCategory(e.target.value)}
                        style={styles.input}
                      >
                        {category && category.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Distributer Name">
                      <Form.Select 
                        aria-label="Distributer Name" 
                        name='distributer_id' 
                        onChange={(e) => setDefaultDistributer(e.target.value)}
                        style={styles.input}
                      >
                        {distributer && distributer.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-3'>
                    <FloatingLabel label="Store Name">
                      <Form.Select 
                        aria-label="Store Name" 
                        name='store_id' 
                        onChange={(e) => setDefaultStore(e.target.value)}
                        style={styles.input}
                      >
                        {store && store.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Product Aisle">
                      <Form.Control 
                        type="text" 
                        name="aisle" 
                        placeholder="Product Aisle" 
                        value={inputProduct.aisle} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Product Bin">
                      <Form.Control 
                        type="text" 
                        name="bin" 
                        placeholder="Product Bin" 
                        value={inputProduct.bin} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Extra Discount">
                      <Form.Control 
                        type="text" 
                        name="extraDiscount" 
                        placeholder="Extra Discount" 
                        value={inputProduct.extraDiscount} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.extraDiscount}</span>
                    </FloatingLabel>
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-6'>
                    <input 
                      className='form-control' 
                      name='image' 
                      type="file" 
                      accept="image/*" 
                      onChange={handleImageChange} 
                      style={styles.input}
                    />
                  </div>
                  <div className='col-md-6'>
                    {imagePreview && <img src={imagePreview} alt="Preview" style={styles.imagePreview} />}
                  </div>
                </Row>
                <Row className="g-3 mt-2">
                  <div className='col-md-4'>
                    <FloatingLabel label="Product Visibility">
                      <Form.Select 
                        aria-label="Product Visibility" 
                        value={inputProduct.hold} 
                        name='hold' 
                        onChange={(e) => handleInput(e)}
                        style={styles.input}
                      >
                        <option value="1">Yes</option>
                        <option value="2">No</option>
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'>
                    <FloatingLabel label="Product Barcode">
                      <Form.Control 
                        type="text" 
                        name="alias" 
                        placeholder="Product Barcode" 
                        value={inputProduct.alias} 
                        onChange={(e) => handleInput(e)} 
                        style={styles.input}
                      />
                      <span style={styles.errorText}>{inputProduct.errorlist.alias}</span>
                    </FloatingLabel>
                  </div>
                  <div className='col-md-4'></div>
                </Row>
                
                <Row className="g-3 mt-2">
                  <div className='col-md-6'>
                    <HsCodeSearchDropdown
                      value={defaultHsCode}
                      onChange={(code) => {
                        setDefaultHsCode(code);
                        setInputProduct(prev => ({ ...prev, hscode: code }));
                      }}
                      placeholder="Search HS Code..."
                      className="mb-2"
                    />
                  </div>
                  <div className="col-md-6">
                    <UOMSelector 
                      hsCode={defaultHsCode}
                      onUOMSelect={handleUOMSelection}
                    />
                  </div>
                </Row>

                <Row className="g-3 mt-2">
                  <div className='col-md-6'>
                    <TransTypeSearchDropdown
                      value={defaultTransType}
                      onChange={handleTransactionChange}
                      placeholder="Search Transaction Type..."
                    />
                  </div>
                  <div className='col-md-6'>
                    <SaleTypeRateDropdown
                      transTypeId={defaultTransTypeId || defaultTransType}
                      originationSupplier="7"
                      onSelect={handleRateSelect}
                      placeholder="Search Sale Type Rate..."
                      className="mb-2"
                      required={false}
                    />
                  </div>
                </Row>

                <Row className='g-3 mt-2'>
                  <div className='col-md-6'>
                    <SroDropdown
                      rateId={inputProduct.rate_id || ''}
                      date={getFormattedDateForSro()}
                      originationSupplier="7"
                      value={inputProduct.sro_id || ''}
                      onSelect={handleSroSelect}
                      placeholder="Search SRO Schedule..."
                      className="mb-2"
                      required={false}
                    />
                  </div>
                  <div className='col-md-6'>
                    <SroItemDropdown
                      sroId={inputProduct.sro_id || ''}
                      date={getFormattedDateForSroItem()}
                      value={inputProduct.sro_item_id || ''}
                      onSelect={handleSroItemSelect}
                      placeholder="Search SRO Item..."
                      className="mb-2"
                      required={false}
                    />
                  </div>
                </Row>

                <Row className="mt-3">
                  <div className='col-md-12'>
                    <button 
                      type='submit' 
                      className='btn btn-success btn-lg' 
                      style={{...styles.button, ...styles.buttonSuccess, width: '100%'}}
                    >
                      {isClick ? <Puff height={23} stroke='yellow' strokeOpacity={1.2} /> : 'Save'}
                    </button>
                  </div>
                </Row>
              </div>
            </form>
          </center>
        )}
      </div>

      {/* Table Section */}
      <Row className='g-1'>
        <div className='col-md' style={styles.tableContainer}>
          <Row className='g-2 mb-3'>
            <div className='col-md-4'>
              <input 
                type="text" 
                className='form-control' 
                placeholder='🔍 Search Item...' 
                value={searchQuery} 
                onChange={handleSearchChange} 
                style={styles.searchBar}
              />
            </div>
            <div className='col-md-3'>
              <button 
                onClick={handleExport} 
                className='btn btn-warning' 
                style={{...styles.button, ...styles.buttonWarning, marginRight: '10px'}}
              >
                {isClick ? <Puff height={10} /> : '📊 Excel'}
              </button>
              <button 
                onClick={handleExportPdf} 
                className='btn btn-success' 
                style={{...styles.button, ...styles.buttonSuccess}}
              >
                {isClick ? <Puff height={10} /> : '📄 PDF'}
              </button>
            </div>
            <div className='col-md-5'>
              <form onSubmit={handleSubmitImport} style={{ display: 'flex', gap: '10px' }}>
                <input 
                  type="file" 
                  onChange={handleFileChange} 
                  className='form-control' 
                  style={styles.input}
                />
                <button 
                  type="submit" 
                  className='btn btn-primary' 
                  style={{...styles.button, ...styles.buttonPrimary}}
                >
                  {isLoading ? '⏳ Please Wait...' : '📤 Upload'}
                </button>
                {error && (
                  <h6 style={{color: 'green', margin: '0', padding: '5px'}}>{error}</h6>
                )}
              </form>
            </div>
          </Row>

          <Table striped bordered hover size="sm" responsive>
            <thead>
              <tr style={styles.tableHeader}>
                <th>#</th>
                <th>Name</th>
                <th style={{display:'none'}}>Image</th>
                <th style={{display:'none'}}>Barcode</th>
                <th style={{display:'none'}}>Aisle</th>
                <th style={{display:'none'}}>Bin</th>
                <th>Status</th>
                <th style={{display:'none'}}>Color</th>
                <th>Unit</th>
                <th>Qty</th>
                <th>Retail</th>
                <th>Cost</th>
                <th>HS Code</th>
                <th>Transaction Type</th>
                <th>Uom</th>
                <th>Fbr Rate</th>
                <th>sroScheduleNo</th>
                <th>Sro.Item.Sr.No</th>
                <th>Category</th>
                <th style={{display:'none'}}>Store</th>
                <th>Distributer</th>
                <th>Delete</th>
                <th>Update</th>
              </tr>
            </thead>
            <tbody>
              {products && products.map((item, index) => (
                <tr 
                  key={item.id} 
                  style={{
                    backgroundColor: item.qty < item.alert ? '#fff5f5' : item.hold === '2' ? '#fee' : 'white'
                  }}
                >
                  <td>{serialStart + index}</td>
                  <td>{item.name}</td>
                  <td style={{display:'none'}}><img width={50} height={50} alt='' src={`${weburl}${item.image}`} style={styles.imagePreview} /></td>
                  <td style={{display:'none'}}>{item.alias}</td>
                  <td style={{display:'none'}}>{item.class}</td>
                  <td style={{display:'none'}}>{item.box}</td>
                  <td>
                    <span style={{
                      padding: '4px 10px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '500',
                      ...(item.hold === '1' 
                        ? { backgroundColor: '#d4edda', color: '#155724' } 
                        : { backgroundColor: '#f8d7da', color: '#721c24' })
                    }}>
                      {item.hold === '1' ? 'Visible' : 'Hidden'}
                    </span>
                  </td>
                  <td style={{display:'none'}}>{item.color}</td>
                  <td>{item.unit}</td>
                  <td>
                    <span style={{
                      padding: '4px 10px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '500',
                      ...(item.qty < item.alert 
                        ? { backgroundColor: '#f8d7da', color: '#721c24' } 
                        : { backgroundColor: '#d4edda', color: '#155724' })
                    }}>
                      {item.qty}
                    </span>
                  </td>
                  <td>{item.unitsaleprice}</td>
                  <td>{item.unitcostprice}</td>
                  <td>{item.hscode || '-'}</td>
                  <td>{item.trans_type_des || '-'}</td>
                  <td>{item.uom_des || '-'}</td>
                  <td>{item.fbr_taxrate_value || '-'}</td>
                  <td>{item.sro_desc || '-'}</td>
                  <td>{item.sro_item_desc || '-'}</td>
                  <td>{item.categoryname}</td>
                  <td style={{display:'none'}}>{item.storename}</td>
                  <td>{item.distributername}</td>
                  <td>
                    <button 
                      className='btn btn-danger btn-sm' 
                      disabled={type !== 'Managment'} 
                      onClick={(e) => handleDelete(e, item.id, index)}
                      style={{padding: '6px 12px', borderRadius: '6px', border: 'none', margin: '0 3px', backgroundColor: '#e74c3c', color: '#fff'}}
                    >
                      {isThisClick === index ? <Puff height={10} width={15} /> : <FaTrash />}
                    </button>
                  </td>
                  <td>
                    <button 
                      onClick={(e) => handleEdit(e, item.id, index)} 
                      className='btn btn-success btn-sm'
                      style={{padding: '6px 12px', borderRadius: '6px', border: 'none', margin: '0 3px', backgroundColor: '#2ecc71', color: '#fff'}}
                    >
                      {isThisClick === index ? <Puff height={10} width={15} /> : <FaEdit />}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div style={styles.pagination}>
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((page) => page - 1)}
              style={{
                borderRadius: '8px',
                padding: '8px 20px',
                border: 'none',
                fontWeight: '500',
                backgroundColor: '#3498db',
                color: '#fff',
                opacity: currentPage === 1 ? 0.5 : 1,
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
              }}
            >
              ⬅ Previous
            </button>
            <span style={{ fontWeight: '600', color: '#2c3e50' }}>
              {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((page) => page + 1)}
              style={{
                borderRadius: '8px',
                padding: '8px 20px',
                border: 'none',
                fontWeight: '500',
                backgroundColor: '#3498db',
                color: '#fff',
                opacity: currentPage === totalPages ? 0.5 : 1,
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
              }}
            >
              Next ➡
            </button>
          </div>
        </div>
      </Row>
    </div>
  )
}

export default Product;